import { render, staticRenderFns } from "./CreateReviewList.vue?vue&type=template&id=f1a2fdbe&scoped=true&"
import script from "./CreateReviewList.vue?vue&type=script&lang=js&"
export * from "./CreateReviewList.vue?vue&type=script&lang=js&"
import style0 from "./CreateReviewList.vue?vue&type=style&index=0&id=f1a2fdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a2fdbe",
  null
  
)

export default component.exports